import React, { useEffect, useRef } from "react";
import { supabase } from "../SupabaseClient.tsx";
import "./LandingPage.css";

declare global {
  interface Window {
    handleSignInWithGoogle: (response: any) => Promise<void>;
    google: any;
  }
}

const LandingPage: React.FC = () => {
  const buttonRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    // Ensure the Google Identity Services library is initialized
    if (window.google && buttonRef.current) {
      window.google.accounts.id.initialize({
        client_id:
          "770499561610-bn7l337pafvj7uf68pn76hhaguvclt2j.apps.googleusercontent.com",
        callback: window.handleSignInWithGoogle,
      });

      // Render the Google Sign-In button
      window.google.accounts.id.renderButton(buttonRef.current, {
        type: "standard",
        shape: "rectangular",
        theme: "outline",
        text: "signin_with",
        size: "large",
        logo_alignment: "left",
        width: 280,
      });
    }
  }, []);

  window.handleSignInWithGoogle = async function (response) {
    const { error } = await supabase.auth.signInWithIdToken({
      provider: "google",
      token: response.credential,
    });

    if (error) {
      console.error("Error signing in with Google:", error);
      return;
    }
  };

  return (
    <div className="landing-page">
      <script src="https://accounts.google.com/gsi/client" async></script>

      <div className="landing-container">
        <div className="landing-content">
          <div className="logo">
            <h1>Shoebox</h1>
          </div>

          <div className="welcome-section">
            <h2>Welcome to Shoebox</h2>
            <p>
              Store, track, and maximize your HSA receipts for better financial
              health
            </p>
          </div>

          <div className="sign-in-section">
            <h3>Sign in to continue</h3>
            <div className="sign-in-options">
              <div ref={buttonRef} className="g_id_signin"></div>
            </div>
          </div>

          <div className="landing-footer">
            <p>
              By signing in, you agree to our{" "}
              <a href="/terms">Terms of Service</a> and{" "}
              <a href="/privacy-policy">Privacy Policy</a>
            </p>
          </div>
        </div>

        <div className="landing-illustration">
          <div className="feature-list">
            <div className="feature-item">
              <h4>Track All Receipts</h4>
              <p>
                Store and organize all your HSA eligible receipts in one place
              </p>
            </div>
            <div className="feature-item">
              <h4>Maximize Tax Benefits</h4>
              <p>See how your HSA investments can grow over time</p>
            </div>
            <div className="feature-item">
              <h4>Smart Receipt Processing</h4>
              <p>
                AI-powered receipt scanning identifies HSA eligible expenses
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Hidden for safety */}
      <div
        id="g_id_onload"
        data-client_id="770499561610-bn7l337pafvj7uf68pn76hhaguvclt2j.apps.googleusercontent.com"
        data-context="signin"
        data-ux_mode="popup"
        data-callback="handleSignInWithGoogle"
        data-auto_select="true"
        data-close_on_tap_outside="false"
        data-itp_support="true"
      ></div>
    </div>
  );
};

export default LandingPage;
